// extracted by mini-css-extract-plugin
export var danger = "_14-6";
export var lightPink = "_14-a";
export var medium = "_14-j";
export var nearSquare = "_14-m";
export var neutralBlue = "_14-8";
export var neutralYellow = "_14-7";
export var noCapitalize = "_14-1";
export var normal = "_14-2";
export var pill = "_14-0";
export var primary = "_14-3";
export var primaryLight = "_14-4";
export var shadow = "_14-n";
export var small = "_14-k";
export var solidBlack = "_14-i";
export var solidGreen = "_14-d";
export var solidLightBlue = "_14-f";
export var solidNavy = "_14-e";
export var solidOrange = "_14-h";
export var solidPink = "_14-g";
export var solidRed = "_14-b";
export var solidWhite = "_14-9";
export var solidYellow = "_14-c";
export var success = "_14-5";
export var xsmall = "_14-l";